import { getPartnerPrograms } from '@/api/partner-programs';
import { useApiQuery } from '@/hooks/api';
import { REFERENCE_STALE_TIME } from '@/hooks/api/defaults';
import { queryKeys } from '@/shared/lib/queryKeys';

import type { PartnerProgram } from '@/types/recruiter';

export function usePartnerProgramsQuery(options?: { enabled?: boolean }) {
  return useApiQuery<PartnerProgram[]>({
    queryKey: queryKeys.admin.partnerPrograms(),
    queryFn: () => getPartnerPrograms(''),
    enabled: options?.enabled ?? true,
    staleTime: REFERENCE_STALE_TIME,
  });
}
